/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/plans" DataTable endpoint
 * @owner @Appboy/email
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdPlans } from "./constants";
import type { EmailIpWarmingAppGroupIdPlansParams, EmailIpWarmingAppGroupIdPlansResult } from "./types";

export const getDataTableEmailIpWarmingAppGroupIdPlans = reactQueryTableFetcherAdapter(
  emailIpWarmingAppGroupIdPlans,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, limit, start, sortby, sortdir }: EmailIpWarmingAppGroupIdPlansParams
  ): Promise<EmailIpWarmingAppGroupIdPlansResult> => {
    return fetch(
      `/email/ip_warming/${appGroupId}/plans`,
      "GET",
      {
        query: serializeQueryObjects(query),
        ...(limit !== undefined && { limit }), // only include limit if defined
        ...(start !== undefined && { start }), // only include start if defined
        ...(sortby && { sortby }), // only the date column is sortable for now
        ...(sortdir && { sortdir }),
      },
      { signal }
    );
  }
);
